import { ReactNode } from "react";
import { IconType } from "react-icons";
import { MdFilterList, MdFilterListOff } from "react-icons/md";
import { FormattedMessage } from "react-intl";
import { FreeSwitch } from "../Switch";

export interface Filters {
  needsApproval: boolean;
}

export interface CompetitionApprovalsFilterProps {
  filters: Filters;
  onFiltersChange?(filters: Filters): void;
}

export default function CompetitionApprovalsFilter(
  props: CompetitionApprovalsFilterProps,
) {
  const onFilterChange = (key: keyof Filters) => (enabled: boolean) => {
    props.onFiltersChange?.({
      ...props.filters,
      [key]: enabled,
    });
  };
  return (
    <Filter
      enabled={props.filters.needsApproval}
      onEnabledChange={onFilterChange("needsApproval")}
      label={<FormattedMessage defaultMessage="Filter pending submissions" />}
      iconEnabled={MdFilterList}
      iconDisabled={MdFilterListOff}
    />
  );
}

interface FilterProps {
  enabled: boolean;
  onEnabledChange?(enabled: boolean): void;
  iconEnabled: IconType;
  iconDisabled: IconType;
  label: ReactNode;
}

const Filter = ({
  enabled,
  onEnabledChange,
  iconEnabled: IconEnabled,
  iconDisabled: IconDisabled,
  label,
}: FilterProps) => (
  <label className="inline-flex gap-4 items-center px-3 py-2 text-gray-600 rounded-lg hover:text-black hover:ring-2 hover:ring-grey">
    {enabled ? (
      <IconEnabled className="text-lg text-indigo" />
    ) : (
      <IconDisabled className="text-lg" />
    )}
    {label}
    <FreeSwitch checked={enabled} onCheckedChange={onEnabledChange} />
  </label>
);
